<template>
	<div v-if="source" class="invoice-supplier-field-source">
		<span class="badge" :class="`invoice-supplier-field-source__badge--${modified ? 'modifie' : source}`">
			{{ $t(`invoice.supplier_source_${modified ? 'modifie' : source}`) }}
		</span>
		<small v-if="confidence && !modified" class="invoice-supplier-field-source__uncertain">
			{{ $t('invoice.supplier_field_uncertain', { pct: confidence }) }}
		</small>
	</div>
</template>


<script type="text/javascript">
	/**
	 * Origine d'un champ pré-rempli depuis une facture fournisseur : lu sur le document, vérifié
	 * auprès de VIES, déduit, ou modifié depuis par l'utilisateur.
	 */
	export default {
		name: "InvoiceSupplierFieldSource",
		props: {
			// facture | vies | deduit, rien si le champ n'a pas été pré-rempli
			source: { type: String, default: '' },
			modified: { type: Boolean, default: false },
			// Confiance de la lecture optique en %, renseignée seulement quand elle est faible
			confidence: { type: Number, default: 0 }
		}
	}
</script>

